import React from 'react'
import { columnNameAsString } from '../../XtractTableUtils.jsx'
import MultiSelectDropdown from 'GeneralUI/MultiSelectDropdown/MultiSelectDropdown.jsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ColumnChooserMenu = ({visible, table, isModal, columnChooserStyles}) => {

  const columnsForPicking = table.getAllLeafColumns()
    .filter(column => !(column.columnDef.showable === false))
    .map(column => {
      // Mirror the per-header / badge logic: a column is "filtered" when
      // TanStack says so AND the column hasn't opted out via isFilterCleared
      // (e.g. multi-select with every option chosen).
      const filterValue = column.getFilterValue?.()
      const cleared = column.columnDef?.isFilterCleared?.(filterValue) ?? false
      const filtered = (column.getIsFiltered?.() ?? false) && !cleared
      return {
        label: columnNameAsString(column.columnDef),
        value: column.id,
        visible: column.getIsVisible(),
        // only set when truthy, so options for unfiltered columns keep their
        // historical {label, value, visible} shape
        ...(filtered ? { filtered: true } : {})
      }
    })
    .filter(column => {
      // don't ever show columns that are marked as not-showable
      return !(column.showable === false)
    })
    .map(column => {
      delete column.showable
      return column
    })

  const selectedColumns = columnsForPicking
    .filter(column => column.visible)

  // if the isModal prop is passed in indicating the table is being displayed in a modal, we need to adjust the zIndex
  // of the column chooser popup menu to show over the modal
  const { menuPortalStyles = {}, ...restStyles } = columnChooserStyles
  if(isModal && !menuPortalStyles.zIndex) {
    menuPortalStyles.zIndex = 1000100 //modal framework starts at 1000000
  }
  return visible ? (
    <div
      className={'column-chooser'}
      data-title={'Select columns to show'}
      data-toggle={'tooltip'}
    >
      <MultiSelectDropdown
        options={columnsForPicking}
        value={selectedColumns}
        styles={{
          option: (baseStyles, state) => (
            {
              ...baseStyles,
              height: '28px'
            }
          ),
          ...restStyles
        }}
        menuPortalStyles={{ width: '200px', ...menuPortalStyles }}
        manySelectedPlaceholder={'Columns'}
        allSelectedPlaceholder={'Columns'}
        includeSelectAll={true}
        getOptionAdornment={option => option.filtered ? (
          <FontAwesomeIcon
            icon={['fas', 'filter']}
            aria-label={'column has active filter'}
            style={{ marginLeft: '6px' }}
          />
        ) : null}
        onChange={(selections) => {
          table?.getAllLeafColumns().forEach(column => {
            const v = selections.some(col => { return col.value === column.id })
            column.toggleVisibility(v)
          })
        }}
        maxMenuHeight={300}
        aria-label={'column chooser dropdown'}
      />
    </div>
  ) : null
}

export default ColumnChooserMenu